// Card-request specifics. The generic SlickPay/SATIM plumbing (contacts,
// invoices, rib generation, the file <-> base64 round trip across the redirect)
// now lives in the `slickpay-js` package — see services/slickpay.js.

import TypeCarteService from "./TypeCarteService";

// Card type -> name as stored in the type-carte table, used both as the
// `name` query param for GET /type-carte/price and as the i18n label key.
export const CARD_TYPE_NAMES = {
  platinum: "Platinum card",
  gold: "Gold card",
  classic: "Classic card",
};

function extractPrice(payload) {
  if (payload == null) return undefined;
  if (typeof payload === "number") return payload;
  if (typeof payload === "string") return Number(payload);
  if (typeof payload.price !== "undefined") return Number(payload.price);
  if (payload.data) return extractPrice(payload.data);
  return undefined;
}

// Fetches the current fee (DA) for every card type from the backend
// (GET /type-carte/price?name=...) instead of relying on hardcoded values
// that can drift from what's actually configured server-side.
export async function fetchCardPrices() {
  const entries = await Promise.all(
    Object.entries(CARD_TYPE_NAMES).map(async ([type, name]) => {
      const { data } = await TypeCarteService.getPrice(name);
      return [type, extractPrice(data)];
    })
  );
  return Object.fromEntries(entries);
}
